module.exports = __webpack_public_path__ + "static/media/TradeGothicForNike365-BdCn.1eff2427.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/TradeGothic/TradeGothicForNike365-BdCn.otf
// module id = 788
// module chunks = 0